import React from 'react';
import classnames from 'classnames';
import get from "lodash/get";
import CheckboxField from '../fields/CheckboxField/CheckboxField';

const CheckboxFieldPanel = (props) => {
  const meta = get(props, 'meta', {});
  const { error, submitFailed } = meta;
  const showError = !!(error && submitFailed);
  const className = classnames({ 'border-error': showError }, 'border-gray-200 rounded-border bg-gray-100 w-100');

  return (
    <div
      style={{ padding: '16px' }}
      className={className}
    >
      <CheckboxField {...props} />
    </div>
  );
};

export default CheckboxFieldPanel;
